import { gql, QueryResult, QueryTuple, useLazyQuery, useQuery } from '@apollo/client';

import { getPolices } from '../../../../utils/gqlPolicesUtil';

export const GET_STUDENT_ACADEMIC_PROGRAMS_QUERY = `
    getStudentAcademicPrograms(studentId: $studentId) {
      studentId
      id: academicProgramId
      name: academicProgramName
    }
`;

export const GET_STUDENT_ACADEMIC_PROGRAMS = gql`
  query GetStudentAcademicPrograms($studentId: NonEmptyString!) {
    ${GET_STUDENT_ACADEMIC_PROGRAMS_QUERY}
  }
`;

export interface IGetStudentAcademicProgramsParams {
  studentId: string;
}

export interface IAcademicProgram {
  id: string;
  name: string;
}

export interface IGetStudentAcademicPrograms {
  getStudentAcademicPrograms: IAcademicProgram[];
}

export const useLazyGetStudentAcademicPrograms = (
  fromCache?: boolean,
): QueryTuple<IGetStudentAcademicPrograms, IGetStudentAcademicProgramsParams> =>
  useLazyQuery<IGetStudentAcademicPrograms, IGetStudentAcademicProgramsParams>(GET_STUDENT_ACADEMIC_PROGRAMS, {
    ...getPolices(fromCache),
  });

export const useQueryGetStudentAcademicPrograms = (
  studentId: string,
  fromCache?: boolean,
  skip?: boolean,
): QueryResult<IGetStudentAcademicPrograms, IGetStudentAcademicProgramsParams> =>
  useQuery<IGetStudentAcademicPrograms, IGetStudentAcademicProgramsParams>(GET_STUDENT_ACADEMIC_PROGRAMS, {
    ...getPolices(fromCache),
    skip,
    variables: {
      studentId,
    },
  });

export const getStudentAcademicProgramsRefetch = async (
  studentId: string,
): Promise<{ data?: IGetStudentAcademicPrograms; error?: any }> => {
  const { client } = await import('../../../../apollo/ApolloConfig');
  const data = await client.query({
    query: GET_STUDENT_ACADEMIC_PROGRAMS,
    variables: {
      studentId,
    },
    fetchPolicy: 'network-only',
  });

  return {
    data: data.data,
    error: data?.error,
  };
};
